require('./aggregatorManageEntities.scss');

import React from 'react';
import PropTypes from 'prop-types';

import { ContentBox } from 'commonsComponents/contentBox';
import { OKLink } from 'commonsComponents/OKLink';
import { AggregatorManageEntitiesAccordion } from './aggregatorManageEntitiesAccordion/aggregatorManageEntitiesAccordion';

const { formatText, FormattedText } = require('core/i18n').i18n;

const TRANSLATION_KEY_PREFIX = 'aggregatorManageEntities';

class AggregatorManageEntitiesClass extends React.PureComponent {
  renderItem = bank => {
    const { removeEntity, toggleActive, onHandleDirty, getSecondFactorAuth, isAggregatorTink } = this.props;

    return (
      <div key={bank.get('name')} className="aggregator-manage-entities__content__products__item">
        <AggregatorManageEntitiesAccordion
          status={bank.get('status')}
          psd2Status={bank.get('psd2Status')}
          bankName={bank.get('name')}
          bankLogo={bank.get('imageUrl')}
          bankId={bank.get('userBankId')}
          bankCode={bank.get('code')}
          products={bank.get('products')}
          removeEntity={removeEntity}
          toggleActive={toggleActive}
          onHandleDirty={onHandleDirty}
          getSecondFactorAuth={getSecondFactorAuth}
          isAggregatorTink={isAggregatorTink}
        />
      </div>
    );
  };

  renderBanksProducts = () => {
    const { productsByBank } = this.props;

    return (
      productsByBank.size > 0 &&
      productsByBank
        .valueSeq()
        .sort((a, b) => b.get('products', { size: 0 }).size - a.get('products', { size: 0 }).size)
        .map(k => this.renderItem(k))
    );
  };

  render() {
    return (
      <ContentBox title={formatText(`${TRANSLATION_KEY_PREFIX}-contentTitle`)}>
        <div className="aggregator-manage-entities__content__text">
          <FormattedText value={`${TRANSLATION_KEY_PREFIX}-contentText`} />
        </div>
        <div className="aggregator-manage-entities__content__products">
          {this.renderBanksProducts()}
        </div>
        <div className="aggregator-manage-entities__content__buttons">
          <OKLink modifier="emphasize" to={'/myprofile/global#pg-other-banks'}>
            <FormattedText value={`${TRANSLATION_KEY_PREFIX}-toPGButton`} />
          </OKLink>
        </div>
      </ContentBox>
    );
  }
}

AggregatorManageEntitiesClass.propTypes = {
  productsByBank: PropTypes.object,
  toggleActive: PropTypes.func,
  removeEntity: PropTypes.func,
  onHandleDirty: PropTypes.func,
  getSecondFactorAuth: PropTypes.func,
    isAggregatorTink: PropTypes.bool
};

module.exports.constructor = AggregatorManageEntitiesClass;
module.exports.AggregatorManageEntities = AggregatorManageEntitiesClass;
